import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { 
  MsalGuard, 
  MsalModule, 
  MsalService, 
  MSAL_GUARD_CONFIG, 
  MSAL_INSTANCE 
} from '@azure/msal-angular';
import { 
  BrowserCacheLocation, 
  IPublicClientApplication, 
  InteractionType, 
  PublicClientApplication,
  BrowserUtils
} from '@azure/msal-browser';
import { OktaAuthService } from '../../../services/okta-auth.service';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

const msalConfig = {
  auth: {
    clientId: '5195a692-8394-4c16-9db9-a5af32c8c443',
    authority: 'https://login.microsoftonline.com/ba5b0a4d-6c68-4ac3-9d6e-c5b5a12a9d69',
    redirectUri: 'https://siteit.pages.dev'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false
  }
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

@Component({
  selector: 'app-login-ibero',
  standalone: true,
  imports: [NgOptimizedImage, MsalModule],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    MsalGuard
  ],
  templateUrl: './login-ibero.html',
  styleUrl: './login-ibero.css'
})
export class LoginIbero implements OnInit {
  private msalInstance: IPublicClientApplication;

  constructor(
    private router: Router,
    private msalService: MsalService,
    private oktaAuth: OktaAuthService) {
    this.msalInstance = new PublicClientApplication(msalConfig);
  }

  async ngOnInit() {
    await this.msalInstance.initialize();
    
    // Handle redirect after login
    if (!BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()) {
      await this.msalInstance.handleRedirectPromise();
    }
  }

  async login() {
    try {
      const result = await this.msalInstance.loginPopup();
      console.log('Login azure successful');
      // console.log('Login azure successful:', result);
      // Handle successful login - store token, navigate, etc.
      this.searchEmailInIbero(result.account.username, result.accessToken)
    } catch (error) {
      console.error('Login failed:', error);
      // Handle login error
    }
  }

  async loginWithOkta() {
    try {
      const result = await this.oktaAuth.login();
      console.log('Login okta successful:', result);
      
      // if (result.tokens?.id_token) {
      //   const decodedToken: any = jwtDecode(result.tokens.id_token);
      //   const email = decodedToken.email;
        
      //   if (email) {
      //     console.log('User email:', email);
      //     // Now you can use the email for searchEmailInIbero
      //     this.searchEmailInIbero(email, result?.id_token);
      //   }
      // }
    } catch (error) {
      console.error('Login failed:', error);
    }
  }

  searchEmailInIbero(email: string, token: string) {
    this.oktaAuth.searchEmailInIbero(email, token).subscribe({
      next: (response: any) => {
        console.log('Ibero Search Response:', response);  
        
        if (response && response.token_autho && response.user_id) {
          // Store the raw response for debugging

          // Create the data object
          const dataToSend = {
            data: {
              user: {
                id: response.user_id,
                nickname: response.nickname
              },
              login: {
                token: response.token_autho
              },
              termsaccept: false,
              email: response.email
            }
          };


          // Store in localStorage
          try {
            localStorage.setItem('gstoken', response.token_autho);
            localStorage.setItem('gsuid', response.user_id.toString());
            localStorage.setItem('gsemail',  response.email);
            
            // Verify storage
            const storedToken = localStorage.getItem('gstoken');
            const storedUid = localStorage.getItem('gsuid');
            
            // console.log('Stored values:', {
            //   token: storedToken,
            //   uid: storedUid
            // });

            if (storedToken && storedUid) {
              this.router.navigate(['/home']);
            } else {
              console.error('Storage verification failed');
            }
          } catch (error) {
            console.error('Error storing data:', error);
          }
        } else {
          console.error('Invalid response format:', response);
        }
      },      
      error: (error) => {
        console.error('Error searching email in Ibero:', error);
      }
    });
  }
}